import { useReducer, useCallback, createContext, useEffect } from 'react';
import { LetterConstants } from '../../types';
import { Actions, FoundLetterProps, UseFindTheLetterState } from './types';
import { initialState, reducers } from './reducers';
import useHint from '../../hooks/use-hint';
import useGame from '../../hooks/use-game';
import useProgress from '../../hooks/use-progress';
import { FindTheLetterInterface } from '../../providers/GameProvider/types';
import { getLetterHintForPages, getFindTheLetterTotal } from '../../util/find-the-letter-util';

export const FindTheLetterContext = createContext<any>([]);

export const FindTheLetterProvider: React.FC<any> = ({ children }) => {
  const [, { setTotal, setFound }] = useProgress();
  const [{ currentData, activityData }] = useGame<FindTheLetterInterface>();
  const [state, dispatch] = useReducer<React.Reducer<UseFindTheLetterState, Actions>>(
    reducers,
    initialState
  );

  const [{ showHint }] = useHint();
  const activityLetter = activityData?.book.characters[0].character;

  const setFoundLetters = useCallback(
    (page: number, foundLetter: FoundLetterProps) => {
      if (foundLetter.value === LetterConstants.CORRECT) {
        setFound(page);
      }
      dispatch({ type: 'SET_FOUND_LETTERS', payload: { page, foundLetter } });
    },
    [dispatch]
  );

  useEffect(() => {
    currentData.forEach((curr) => setTotal(curr.page?.pageNumber, getFindTheLetterTotal(curr)));
  }, [currentData]);

  useEffect(() => {
    if (!showHint) {
      dispatch({
        type: 'SET_HINT_LETTER',
        payload: { hint: { letterId: undefined, pageNumber: undefined } },
      });
      return;
    }

    const letterHint = getLetterHintForPages(currentData, state.pages, activityLetter);

    if (letterHint) {
      dispatch({
        type: 'SET_HINT_LETTER',
        payload: {
          hint: {
            ...letterHint,
          },
        },
      });
    }
  }, [showHint]);

  return (
    <FindTheLetterContext.Provider
      value={[
        state,
        {
          setFoundLetters,
        },
      ]}
    >
      {children}
    </FindTheLetterContext.Provider>
  );
};

export default FindTheLetterProvider;
